import api from '../api'
import find from 'lodash/find'
import {fetchUser} from './user'
import {fetchUserConfig} from './userConfig'
import {fetchPollsForSet,fetchPollsForQuestion} from './polls'
import {fetchControl} from './control'
import {fetchSections} from './sections'
import {fetchService} from './service'
import {fetchMeta} from './meta'
import {syncClock} from './syncClock'
import {fetchGeoInfo} from './geoInfo'
import {fetchARepoAndPermissions,fetchRepos} from './repos'	
import {fetchSetPolls,fetchQuestionPolls} from './polls'
import {fetchLocksForRepo} from './locks'
import store from '../store'
import {fetchBilling} from './billing'
import {fetchReviewsForUser} from './reviews'
import {fetchSubmissions} from './submissions'
import {fetchSearchKey} from './searchKey'
import {fetchRecentSymbols} from './recentSymbols'
import {fetchSymbolsList} from './recentSymbols'


function loadCommonData(dispatch,itemId,userId,isSet,isNewItem){
	dispatch(fetchUser(userId))
	dispatch(fetchUserConfig(userId))
	dispatch(fetchSymbolsList())
	dispatch(fetchRecentSymbols())
	dispatch(fetchRepos())
	dispatch(fetchSearchKey())
	dispatch(fetchService())
	dispatch(fetchBilling())
	dispatch(fetchReviewsForUser())
	dispatch(fetchControl())
	if(isSet && !isNewItem){
		dispatch(fetchPollsForSet(itemId))
	}else if(!isSet && !isNewItem){
		dispatch(fetchPollsForQuestion(itemId))
	}

	dispatch(fetchSetPolls())//fix for editor NP thing
	dispatch(fetchQuestionPolls())
	dispatch(fetchSections())
	dispatch(fetchMeta())
	dispatch(fetchGeoInfo())
	dispatch(fetchSubmissions())
	dispatch(fetchControl())
	setTimeout(function() { //Wait for requests to finish before sync clock
		dispatch(syncClock())
	},	5000)
}

						
export function loadRichEditorData(itemId,userId,isSet) {
	if(isSet){
		if(itemId !=='newSet' && itemId !=='newSet/'){
			return (dispatch) => {
				api.fetch(`/sets/${itemId}`)
					.then((response) => {
						dispatch({ type: 'FETCH_A_SET_SUCCESS', response })
						if(response.repo){
							let promises=[]
							promises.push(dispatch(fetchARepoAndPermissions(response.repo)))
							promises.push(dispatch(fetchLocksForRepo(response.repo)))

							Promise.all(promises).then(function () {
								const state = store.getState()
								const parentRepo = find(state.repos, {'id':response.repo})
								if(parentRepo && parentRepo.shared){
									let lockState='unlocked'
									const repoLocks=state.locks[response.repo]
									const lock = find(repoLocks, function(lock) {
	    							return lock.item === itemId
									})
							
									if(lock && state.user){
										if(lock.user !== state.user.id){
											lockState='lockedByAnotherUser'
										}
									}
									window.analytics.track('Open Shared Item',{
										itemType:'set',
										lockState:lockState
									})	
								}
							})
						}
						const isNewItem=false
						loadCommonData(dispatch,itemId,userId,isSet,isNewItem)
					})
					.catch(err => {})
			}
		}else{
			return (dispatch) => {
				api.fetch('/control')
					.then((response) => {
						dispatch({ type: 'FETCH_CONTROL_SUCCESS', response })
						const isNewItem=true
						loadCommonData(dispatch,itemId,userId,isSet,isNewItem)
					})
					.catch(err => {})
			}
		}
	}
	else{
		if(itemId !=='newquestion' && itemId !=='newquestion/'){
			return (dispatch) => {
				api.fetch(`/questions/${itemId}`)
					.then((response) => {
						dispatch({ type: 'FETCH_A_QUESTION_SUCCESS', response })
						if(response.repo){
							let promises=[]
							promises.push(dispatch(fetchARepoAndPermissions(response.repo)))
							promises.push(dispatch(fetchLocksForRepo(response.repo)))
							Promise.all(promises).then(function () {
								const state = store.getState()
								const parentRepo = find(state.repos, {'id':response.repo})
								if(parentRepo && parentRepo.shared){
									let lockState='unlocked'
									const repoLocks=state.locks[response.repo]
									const lock = find(repoLocks, function(lock) {
	    							return lock.item === itemId
									})
									if(lock && state.user){
										if(lock.user !== state.user.id){
											lockState='lockedByAnotherUser'
										}
									}
									window.analytics.track('Open Shared Item',{
										itemType:'question',
										lockState:lockState
									})	
								}
							})
						}
						const isNewItem=false
						loadCommonData(dispatch,itemId,userId,isSet,isNewItem)					
					})
					.catch(err => {})
			}
		}else{
			return (dispatch) => {
				api.fetch('/control')
					.then((response) => {
						dispatch({ type: 'FETCH_CONTROL_SUCCESS', response })
						const isNewItem=true
						loadCommonData(dispatch,itemId,userId,isSet,isNewItem)
					})
					.catch(err => {})
			}
		}
	}
}

